import { MobileValidatorUAE } from '../../AddressPage/utils';

export const validationHandler = (validationType, fieldValue, isUae) => {
  if (typeof fieldValue === 'undefined' || fieldValue?.length == 0)
    return false;
  // check this function
  switch (validationType) {
    case '1': // email
      return /^[^\s@]+@[^\s@]+$/.test(fieldValue);
    case '2': //mobile
      if (isUae) return MobileValidatorUAE(fieldValue) && !isNaN(fieldValue);
      else
        return (
          new RegExp('[6-9]{1}[0-9]{9}').test(fieldValue) &&
          fieldValue?.length >= 9
        );
    case '3': //due_date
      const inputDate = new Date(fieldValue);
      const currentDate = new Date();
      return inputDate > currentDate;
    case '4': // fullname
      return fieldValue?.length >= 3 && /[a-zA-Z].*/.test(fieldValue);
    // case "5": // pincode
    //     return new RegExp("^[1-9]{1}[0-9]{2}\\s{0, 1}[0-9]{3}$").test(
    //         fieldValue,
    //     );
    default:
      return true;
  }
};
